const css = `:root {
  --text-bg: hsl(0, 0%, 97%);
  --gray-border: hsla(0, 0%, 0%, 0.1);
  --gray: rgba(0, 0, 0, 0.6);
  --border-radius: 5px;
  --orange: hsl(24, 100%, 50%);
  --distill-blue: hsl(200, 50%, 25%);
  --blue: #337699;
  --green: #3db867;
  --text-fg: rgb(15, 15, 15);
  --text-red: rgb(220, 0, 0);
  --bar-col: rgb(171, 199, 227);
  --link-col: rgb(0, 0, 238);
  --placeholder-col: rgb(166, 166, 166);
  --note-bg: #e1f5fe;
  --note-fg: #1a6ebb;
  --warn-bg: #ffe1aa;
  --warn-fg: #a16800;
  --error-bg: #850000;
  --error-fg: white;
}
@media (prefers-color-scheme: dark) {
  :root {
    --text-bg: rgb(56, 56, 56);
    --text-fg: rgb(213, 213, 213);
    --bar-col: rgb(20, 109, 163);
    --link-col: rgb(66, 165, 245);
    --note-fg: rgb(121 157 190);
    --note-bg: rgb(2 59 85);
    --warn-bg: #784e00;
    --warn-fg: #edbe68;
  }
}

html {
  font-size: 14px;
  line-height: 1.6em;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Arial, sans-serif;
  text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  color: var(--text-fg);
  background: var(--text-bg);
}
@media (min-width: 1200px) {
  html {
    width: 1024px;
    margin: 0 auto;
  }
}
@media (min-width: 768px) {
  html {
    font-size: 16px;
  }
}
html body {
  margin: 0;
  padding: 0rem 1rem 10rem;
}

a,
a:visited {
  color: var(--link-col);
}

h1 {
  font-weight: 700;
  font-size: 2rem;
  line-height: 1.3em;
}

p {
  font-size: 1.06rem;
  line-height: 1.3em;
}

input {
  font-size: 1rem;
}
input::placeholder {
  color: var(--placeholder-col);
}

.note {
  font-style: normal;
  border: none;
  border-radius: 2px;
  margin-left: auto;
  margin-right: auto;
  padding: 0.5rem 0.5rem 0.5rem 2rem;
  width: 90%;
  background-color: var(--note-bg);
  color: var(--note-fg);
}
@media only screen and (max-device-width: 800px) and (orientation: portrait) {
  .note {
    width: 100%;
    padding: 0.5rem;
    box-sizing: border-box;
  }
}
.note.warning {
  background-color: var(--warn-bg);
  color: var(--warn-fg);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
